import { render, staticRenderFns } from "./breeder-mating-details-component.vue?vue&type=template&id=1af8db92&scoped=true&lang=pug"
import script from "./breeder-mating-details-component.js?vue&type=script&lang=js&external"
export * from "./breeder-mating-details-component.js?vue&type=script&lang=js&external"
import style0 from "./breeder-mating-details-component.vue?vue&type=style&index=0&id=1af8db92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af8db92",
  null
  
)

export default component.exports